module.exports = __webpack_public_path__ + "img/srbsw.679e41a8.jpg";